module.exports = __webpack_public_path__ + "img/logo_v2_vertical.f5d1fcb3.png";